import { ChangeNameScreen } from '@/screens/name-screen/ChangeNameScreen'

export default function () {
  return <ChangeNameScreen />
}
